import React from 'react';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
// import InlineSpinner from 'components/generic/InlineSpinner.component';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import OpenIntercomButton from './OpenIntercomButton.component';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const ButtonsPanel = () => (
  <div data-bem="ButtonsPanel" className={CN.container}>
    <div className={CN.container}>
      <div className={CN.verticalFlex}>
        <div className={CN.inline}>
          <OpenIntercomButton />
          <Button variant="outline" width="small" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="outline" width="medium" onClick={alwaysNoop}>
            outline medium
          </Button>
          <Button variant="outline" width="medium" onClick={alwaysNoop} disabled>
            outline medium
          </Button>
          <Button variant="outline" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>OUTLINE WITH ICON</span>
            </div>
          </Button>
          <Button variant="outline" height="max" onClick={alwaysNoop}>
            outline max
          </Button>
          <Button variant="outline" height="max" onClick={alwaysNoop} disabled>
            outline max
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="outlineForce" width="small" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="outlineForce" width="medium" onClick={alwaysNoop}>
            outlineForce medium
          </Button>
          <Button variant="outlineForce" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>OUTLINEFORCE WITH ICON</span>
            </div>
          </Button>
          <Button variant="outlineForce" width="medium" onClick={alwaysNoop} disabled>
            outlineForce medium
          </Button>
          <Button variant="outlineForce" height="max" onClick={alwaysNoop}>
            outlineForce max
          </Button>
          <Button variant="outlineForce" height="max" onClick={alwaysNoop} disabled>
            outlineForce max
          </Button>
          <p>The main difference in button senary is shadow and dark mode</p>
          <br />
          <Button variant="senary" onClick={alwaysNoop}>
            senary
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="emphasis" width="small" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="emphasis" width="medium" onClick={alwaysNoop}>
            emphasis medium
          </Button>
          <Button variant="emphasis" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="off" width="sm" />
              <span className={CN.withIcon}>EMPHASIS WITH ICON</span>
            </div>
          </Button>
          <Button variant="emphasis" width="medium" onClick={alwaysNoop} disabled>
            emphasis medium
          </Button>

          <Button variant="emphasis" height="max" onClick={alwaysNoop}>
            emphasis max
          </Button>
          <Button variant="emphasis" height="max" onClick={alwaysNoop} disabled>
            emphasis max
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="tertiary" width="small" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="tertiary" width="medium" onClick={alwaysNoop}>
            tertiary medium
          </Button>
          <Button variant="tertiary" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>TERTIARY WITH ICON</span>
            </div>
          </Button>
          <Button variant="tertiary" width="medium" onClick={alwaysNoop} disabled>
            tertiary medium
          </Button>
          <Button variant="tertiary" height="max" onClick={alwaysNoop}>
            tertiary max
          </Button>
          <Button variant="tertiary" height="max" onClick={alwaysNoop} disabled>
            tertiary max
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="primary" width="small" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="primary" width="medium" onClick={alwaysNoop}>
            primary medium
          </Button>
          <Button variant="primary" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="off" width="sm" />
              <span className={CN.withIcon}>PRIMARY WITH ICON</span>
            </div>
          </Button>
          <Button variant="primary" width="medium" onClick={alwaysNoop} disabled>
            primary medium
          </Button>
          <Button variant="primary" height="max" onClick={alwaysNoop}>
            primary max
          </Button>
          <Button variant="primary" height="max" onClick={alwaysNoop} disabled>
            primary max
          </Button>
        </div>

        <div className={CN.inline}>
          <Button variant="quinary" width="small" height="medium" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="quinary" onClick={alwaysNoop}>
            quinary
          </Button>
          <Button variant="quinary" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>QUINARY WITH ICON</span>
            </div>
          </Button>
          <Button variant="quinary" onClick={alwaysNoop} disabled>
            quinary
          </Button>
          <Button variant="quinary" height="max" onClick={alwaysNoop}>
            quinary
          </Button>
          <Button variant="quinary" height="max" onClick={alwaysNoop} disabled>
            quinary
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="quinaryActive" width="small" height="medium" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="quinaryActive" onClick={alwaysNoop}>
            quinaryActive
          </Button>
          <Button variant="quinaryActive" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>QUINARY WITH ICON</span>
            </div>
          </Button>
          <Button variant="quinaryActive" onClick={alwaysNoop} disabled>
            quinaryActive
          </Button>
          <Button variant="quinaryActive" height="max" onClick={alwaysNoop}>
            quinaryActive
          </Button>
          <Button variant="quinaryActive" height="max" onClick={alwaysNoop} disabled>
            quinaryActive
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="quinarySelected" width="small" height="medium" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="quinarySelected" onClick={alwaysNoop}>
            quinarySelected
          </Button>
          <Button variant="quinarySelected" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>QUINARY WITH ICON</span>
            </div>
          </Button>
          <Button variant="quinarySelected" onClick={alwaysNoop} disabled>
            quinarySelected
          </Button>
          <Button variant="quinarySelected" height="max" onClick={alwaysNoop}>
            quinarySelected
          </Button>
          <Button variant="quinarySelected" height="max" onClick={alwaysNoop} disabled>
            quinarySelected
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="alert" width="small" onClick={alwaysNoop}>
            alert
          </Button>
          <Button variant="alert" onClick={alwaysNoop}>
            alert
          </Button>
          <Button variant="alert" height="max" onClick={alwaysNoop}>
            alert
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="secondary" onClick={alwaysNoop}>
            SECONDARY
          </Button>
          <Button variant="secondary" onClick={alwaysNoop} disabled>
            SECONDARY
          </Button>
          <Button variant="icon">
            <div className={CN.buttonInner}>
              <Icon variant="markCircle" />
              With icon
            </div>
          </Button>
        </div>
        <div className={CN.inline}>
          <Button variant="stripped" width="small" height="medium" onClick={alwaysNoop}>
            sm
          </Button>
          <Button variant="stripped" onClick={alwaysNoop}>
            stripped
          </Button>
          <Button variant="stripped" onClick={alwaysNoop} disabled>
            stripped
          </Button>
          <Button variant="stripped" width="medium">
            <div className={CN.buttonInner}>
              <Icon variant="shield" width="sm" />
              <span className={CN.withIcon}>STRIPED WITH ICON</span>
            </div>
          </Button>
          <Button variant="stripped" height="max" onClick={alwaysNoop}>
            stripped
          </Button>
          <Button variant="stripped" height="max" onClick={alwaysNoop} disabled>
            stripped
          </Button>
        </div>

        <div className={CN.inline}>
          <div className={CN.space}>
            <Button variant="bin" onClick={alwaysNoop}>
              <Icon variant="arrowPrev" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="bin" onClick={alwaysNoop}>
              <Icon variant="arrowNext" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="bin" onClick={alwaysNoop}>
              <Icon variant="delete" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="bin" stripped onClick={alwaysNoop}>
              <Icon variant="bin" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="bin" stripped onClick={alwaysNoop}>
              <Icon variant="delete" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="bin" onClick={alwaysNoop}>
              <Icon variant="download" width="lg" />
            </Button>
          </div>

          <div className={CN.space}>
            <Button variant="icon" width="small" onClick={alwaysNoop}>
              <Icon variant="calendar" width="lg" />
            </Button>
          </div>
          <div className={CN.space}>
            <Button variant="icon" width="small" onClick={alwaysNoop}>
              <Icon variant="closeDark" width="lg" />
            </Button>
          </div>
          <Button variant="fb" onClick={alwaysNoop}>
            <div className={CN.buttonInner}>
              <Icon variant="fbWhite" width="lg" />
              <span className={CN.withIcon}>Login with Facebook</span>
            </div>
          </Button>
        </div>
        <div className={CN.inline}>
          <div className={CN.space}>
            <Button variant="outlineGrayscale" onClick={alwaysNoop}>
              <span className={CN.buttonInner}>
                <Icon variant="pencil" width="lg" />
                <span className={CN.withIcon}>outlineGrayscale</span>
              </span>
            </Button>
          </div>
          NOTE: the button is Grayscale in the dark theme
        </div>
      </div>
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default ButtonsPanel;
